import { useTranslation } from 'react-i18next';
import { S, Icon, Icons, StatusBadge } from '../../regureStyles';

const Header = ({ onBack, carrier }) => {
  const { t } = useTranslation();
  return (
    <header
      style={{ padding: '20px 32px', borderBottom: `1px solid ${S.borderLight}`, background: 'rgba(255,255,255,0.85)', backdropFilter: 'blur(20px)', flexShrink: 0 }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button
            onClick={onBack}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 34,
              height: 34,
              borderRadius: 8,
              border: `1px solid ${S.borderLight}`,
              background: '#fff',
              cursor: 'pointer',
            }}
          >
            <Icon name='arrowLeft' color={S.textSecondary} size={16} />
          </button>
          <div>
            <div style={{ fontSize: 12, color: S.textMuted, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
              {t('screens.riskCarriers.detailAdministration', { defaultValue: 'Administration' })} {Icons.chevronRight(S.textMuted, 12)} {t('screens.riskCarriers.detailCarriersCrumb', { defaultValue: 'Risk Carriers' })} {Icons.chevronRight(S.textMuted, 12)}
              <span style={{ color: S.textPrimary, fontWeight: 500 }}>{carrier.name}</span>
            </div>
            <div style={{ fontSize: 20, fontWeight: 700, color: S.textPrimary }}>{carrier.name}</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          {carrier.code && (
            <span
              style={{
                padding: '4px 10px',
                background: S.bgCard,
                border: `1px solid ${S.borderLight}`,
                borderRadius: 6,
                fontSize: 12,
                fontWeight: 700,
                color: S.textMuted,
                fontFamily: 'monospace',
              }}
            >
              {carrier.code}
            </span>
          )}
          <StatusBadge status={carrier.status} />
        </div>
      </div>
    </header>
  );
};

export default Header;
